import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-3 px-4 z-50 shadow-lg" data-id="element-278">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-4" data-id="element-279">
        <span className="font-bold text-lg" data-id="element-280">Questa offerta scade presto</span>
        <CountdownTimer data-id="element-281" />
      </div>
    </div>;
}